import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinSubscriptionEditRoute: InvariantJiraRoute = {
	name: 'legacy-gin-subscription-edit',
	path: '(/secure/|/)EditSubscription([!%]?[\\w]*).jspa',
};
